import { Alert } from '@mui/material'
import { useEoValue } from '~/src/hooks/useEoState'
import { FIRM_SELECTOR } from '~/src/stores/firm'
import { LANGUAGE_STATE } from '~/src/stores/lang'
import { Firm, LanguageType, ShopNotification } from '@eo-storefronts/eo-core'
import Title from '~/src/components/mui-wrappers/Title'

const FirmNotification = () => {
  const firm: Firm | null  = useEoValue(FIRM_SELECTOR)
  const lang: LanguageType = useEoValue(LANGUAGE_STATE)
  const label: string = firm?.labels?.shop_notification?.[lang] ?? ''
  const shopNotification: ShopNotification | undefined = firm?.settings?.shopNotification

  if (!firm || !shopNotification?.active || label === '') {
    return null
  }

  const hasCustomColor: boolean = !!shopNotification?.color && !!shopNotification?.backgroundColor

  return (
    <Alert
      id='firm_notification'
      severity={hasCustomColor ? undefined : 'info'}
      icon={false}
      sx={{
        p: 2,
        my: 2,
        whiteSpace: 'pre-line',
        ...(hasCustomColor && {
          backgroundColor: shopNotification!.backgroundColor,
          color: shopNotification!.color
        })
      }}>
      <Title>{ label }</Title>
    </Alert>
  )
}

export default FirmNotification
